import SellingPlan from "./SellingPlan";

export default class SellingPlanGroup {
  SellingPlans: SellingPlan[] = [];
  name!: string;

  constructor(response?: any) {
    if (response != null) {
      this.name = response.name;
      this.SellingPlans = (response.sellingPlans.edges || []).map(
        ({ node }: any) => {
          return new SellingPlan(node);
        }
      );
    }
  }
}
